import Swiper, { Autoplay } from 'swiper'

document.addEventListener('DOMContentLoaded', () => {
  const sliderWrappers = document.querySelectorAll('.mtt-cities-slider')

  if (sliderWrappers.length > 0) {
    sliderWrappers.forEach(sliderWrapper => {
      const swiperElement = sliderWrapper.querySelector('.mtt-cities-slider__swiper')

      const swiperOptions = {
        modules: [Autoplay],
        speed: 800,
        spaceBetween: 16,
        slidesPerView: 1.1,
        allowTouchMove: false,
        loop: true,
        loopAdditionalSlides: 4,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        breakpoints: {
          401: {
            slidesPerView: 1.25
          },
          451: {
            slidesPerView: 1.5
          },
          501: {
            slidesPerView: 1.5
          },
          580: {
            slidesPerView: 1.75
          },
          651: {
            slidesPerView: 2
          },
          761: {
            slidesPerView: 2.25
          },
          901: {
            slidesPerView: 2.5,
            spaceBetween: 24
          },
          1001: {
            slidesPerView: 3,
            spaceBetween: 32
          },
          1161: {
            slidesPerView: 3.5
          },
          1351: {
            slidesPerView: 4
          }
        }
      }

      const swiper = new Swiper(swiperElement, swiperOptions)
    })
  }
})
